import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.ayushcareservices.com',
    withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: 'https://api.ayushcareservices.com',
    headers: { "Content-Type": "application/json" },
    withCredentials: true
});

//https://api.ayushcareservices.com